import { jsx } from "react/jsx-runtime";
import CancelIcon from "@mui/icons-material/Cancel";
import { validateTidalLicense } from "../../base/index.js";
function Cancel(props) {
  return /* @__PURE__ */ jsx(
    CancelIcon,
    {
      "data-testid": "Cancel",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Cancel",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
Cancel.tidalIconMeta = {
  categories: "cancel,informative",
  name: "Cancel"
};
validateTidalLicense();
export {
  Cancel
};
//# sourceMappingURL=Cancel.js.map
